import {stripLegacyCityFromPathname} from "../../../../common/app/routing/strip_legacy_city_from_pathname";
import {setAppStatus} from "../../../app_status/app_status_slice";
import {IActionContext} from "../create_path_to_action";
import {ResponseStatus} from "../state/app_status/IAppStatusState";
import {setAuthAndUser} from "./set_auth_and_user";

export const legacyCityInUrlRedirectAction = async (ctx: IActionContext<Record<string, never>>) => {
    await setAuthAndUser(ctx.store);

    const pathname = ctx.route.pathname;
    const nextPath = stripLegacyCityFromPathname(pathname);

    if (nextPath == null) {
        return;
    }

    ctx.store.dispatch(
        setAppStatus({
            responseStatus: ResponseStatus.REDIRECT_301,
            url: nextPath
        })
    );
};
